{
  "acciones": {
    "guardar": "Salvar",
    "cancelar": "Cancelar",
    "buscar": "Buscar",
    "volver": "Voltar",
    "confirmar": "Confirmar",
    "reintentar": "Tentar de novo",
    "salir": "Sair",
    "activar": "Ativar",
    "desactivar": "Desativar",
    "agregar": "Adicionar",
    "siguiente": "Próximo",
    "imprimir": "Imprimir",
    "quitar": "Remover",
    "corregir": "Corrigir"
  },
  "estados": {
    "cargando": "Carregando…",
    "vacio": "Ainda não há nada para mostrar",
    "error": "Não foi possível concluir a operação"
  },
  "tema": {
    "titulo": "Tema",
    "claro": "Claro",
    "oscuro": "Escuro",
    "sistema": "Do sistema"
  },
  "idioma": {
    "titulo": "Idioma"
  },
  "salud": {
    "titulo": "Estado do sistema",
    "operativo": "Operacional",
    "degradado": "Degradado",
    "caido": "Fora do ar",
    "version": "Versão",
    "entorno": "Ambiente",
    "tiempoActivo": "Tempo ativo",
    "segundos": "{{cantidad}} s",
    "sinConexion": "Não foi possível consultar o estado do servidor",
    "estado": "Estado"
  },
  "navegacion": {
    "titulo": "Seções",
    "contenido": "Conteúdo",
    "inicio": "Início",
    "sucursales": "Filiais",
    "auditoria": "Auditoria",
    "empresaActiva": "Empresa ativa",
    "estructura": "Depósitos e caixas",
    "gente": "Pessoas e papéis",
    "configuracion": "Configuração",
    "catalogo": "Itens",
    "precios": "Preços",
    "existencias": "Estoque",
    "caja": "Caixa",
    "mostrador": "Balcão",
    "mayorista": "Atacado",
    "proveedores": "Fornecedores",
    "compras": "Compras",
    "clientes": "Clientes",
    "cuentas": "Contas correntes",
    "pagos": "Pagamentos a fornecedores",
    "devoluciones": "Devoluções",
    "contabilidad": "Plano de contas",
    "asientos": "Lançamentos",
    "libros": "Livros",
    "libroDeIva": "Livro de IVA",
    "ejercicios": "Exercícios",
    "importacion": "Importar",
    "bancos": "Bancos",
    "comisiones": "Comissões",
    "produccion": "Montagem",
    "grupos": {
      "vender": "Vender",
      "stock": "Estoque",
      "comprar": "Comprar",
      "plata": "Dinheiro",
      "contabilidad": "Contabilidade",
      "configurar": "Configurar",
      "administrar": "Administrar"
    },
    "irA": "Ir para…",
    "irAAyuda": "Escreva o nome de uma tela",
    "irASinNada": "Nenhuma tela com esse nome.",
    "tiposDeComprobante": "Tipos de comprovante",
    "conversiones": "Faturar entregas",
    "rubros": "Grupos",
    "recalculo": "Recalcular preços",
    "numeradores": "Numeradores",
    "plegar": "Recolher o menu",
    "desplegar": "Expandir o menu",
    "campos": "Campos próprios",
    "plataforma": "Plataforma"
  },
  "acceso": {
    "subtitulo": "Entre com sua conta",
    "subtituloSegundoFactor": "Segunda etapa",
    "correo": "E-mail",
    "contrasena": "Senha",
    "codigo": "Código",
    "ayudaCodigo": "Do seu aplicativo de autenticação, ou um de recuperação",
    "entrar": "Entrar",
    "confirmar": "Confirmar",
    "titulo": "Entrar",
    "presentacion": "Administração comercial para lojas que vendem todos os dias."
  },
  "empresa": {
    "elegir": "Escolha uma empresa",
    "sinEmpresas": "Você ainda não tem nenhuma empresa",
    "ayudaSinEmpresas": "Quando cadastrar seu comércio, ele vai aparecer aqui.",
    "administrarPlataforma": "Administrar a plataforma",
    "suspendida": "Suspenso pela plataforma"
  },
  "inicio": {
    "descripcion": "Como vai o dia.",
    "tuAcceso": "Seu acesso",
    "persona": "Pessoa",
    "permisos": "Permissões"
  },
  "sucursales": {
    "titulo": "Filiais",
    "descripcion": "As lojas e depósitos do seu comércio.",
    "nueva": "Nova filial",
    "ayudaNueva": "O código não pode se repetir dentro da empresa.",
    "codigo": "Código",
    "nombre": "Nome",
    "ciudad": "Cidade",
    "estado": "Situação",
    "acciones": "Ações",
    "activa": "Ativa",
    "inactiva": "Inativa",
    "ayudaCodigo": "Curto e fácil de dizer em voz alta",
    "vacio": "Ainda não há nenhuma filial cadastrada."
  },
  "modulos": {
    "organizacion": "Organização",
    "accesos": "Acessos",
    "auditoria": "Auditoria",
    "existencias": "Estoque",
    "caja": "Caixa",
    "impuestos": "Impostos",
    "comisiones": "Comissões",
    "cuentas-corrientes": "Contas correntes",
    "comprobantes": "Documentos",
    "produccion": "Produção"
  },
  "opciones": {
    "FIFO": "PEPS",
    "PROMEDIO_PONDERADO": "Média ponderada",
    "MITAD_AFUERA": "Comercial",
    "MITAD_PAR": "Bancário",
    "AL_EMITIR": "Na emissão",
    "AL_COBRAR": "No recebimento",
    "MANUAL": "Manual",
    "MAS_ANTIGUO_PRIMERO": "Mais antigo primeiro",
    "A_CUENTA": "Por conta",
    "EMISION": "Desde a emissão",
    "ENTREGA": "Desde a entrega",
    "es-AR": "Espanhol",
    "en": "Inglês",
    "pt-BR": "Português"
  },
  "estructura": {
    "titulo": "Depósitos e caixas",
    "descripcion": "Tudo o que depende de uma filial.",
    "depositos": "Depósitos",
    "ayudaDepositos": "Onde a mercadoria fica guardada.",
    "cajas": "Caixas",
    "ayudaCajas": "Os postos onde se recebe.",
    "puntosDeVenta": "Pontos de venda",
    "ayudaPuntosDeVenta": "A numeração legal dos documentos corre por ponto de venda, não por filial.",
    "nuevoDeposito": "Novo depósito",
    "nuevaCaja": "Novo caixa",
    "nuevoPuntoDeVenta": "Novo ponto de venda",
    "sinDepositos": "Ainda não há depósitos.",
    "sinCajas": "Ainda não há caixas.",
    "sinPuntosDeVenta": "Ainda não há pontos de venda.",
    "sucursal": "Filial",
    "elegirSucursal": "Escolha uma filial",
    "codigo": "Código",
    "nombre": "Nome",
    "numero": "Número",
    "modo": "Emissão",
    "predeterminado": "Padrão",
    "si": "Sim",
    "ayudaNumero": "O atribuído pela administração fiscal",
    "modos": {
      "interno": "Interno",
      "manual": "Manual",
      "electronico": "Eletrônico",
      "controlador_fiscal": "Impressora fiscal"
    },
    "corregir": "Corrigir",
    "enUso": "Em uso"
  },
  "gente": {
    "titulo": "Pessoas e papéis",
    "descripcion": "Quem faz parte do comércio e o que pode fazer.",
    "equipo": "Equipe",
    "roles": "Papéis",
    "ayudaRoles": "Um papel é um conjunto de permissões.",
    "persona": "Pessoa",
    "rol": "Papel",
    "alcance": "Filiais",
    "estado": "Situação",
    "tipo": "Tipo",
    "permisos": "Permissões",
    "personas": "Pessoas",
    "activa": "Ativa",
    "inactiva": "Inativa",
    "deSistema": "Do sistema",
    "todasLasSucursales": "Todas",
    "invitar": "Convidar alguém",
    "ayudaInvitar": "Vai receber um link para escolher a senha.",
    "correo": "E-mail",
    "elegirRol": "Escolha um papel",
    "enviarInvitacion": "Convidar",
    "invitacionLista": "Convite pronto. Passe este link:",
    "nuevoRol": "Novo papel",
    "ayudaNuevoRol": "Escolha o que pode fazer quem tiver este papel.",
    "codigoDelRol": "Código",
    "nombreDelRol": "Nome",
    "tiposDeComprobante": "Comprovantes",
    "corregirPersona": "Corrigir pessoa",
    "ayudaCorregirPersona": "O papel, até onde alcança e se ainda trabalha aqui.",
    "corregirRol": "Corrigir papel",
    "ayudaCorregirRol": "O nome e o que pode fazer. O código não muda: quem o nomeia são as regras.",
    "estadoDeLaMembresia": "Ainda trabalha aqui",
    "ayudaEstadoDeLaMembresia": "Ao desativar, não entra mais. Nada é apagado: o que fez continua em seu nome.",
    "ayudaTodasLasSucursales": "Sem restrição, vê e opera em todas. Ao restringir, só nas marcadas.",
    "sucursalPredeterminada": "Filial de sempre",
    "ayudaSucursalPredeterminada": "Aquela em que começa ao entrar. Só entre as que tem permitidas.",
    "sinPredeterminada": "Que escolha ao entrar",
    "permisosDelDuenio": "O papel de dono tem todas as permissões e não se tiram: uma empresa sem dono não se conserta por dentro.",
    "eliminarRol": "Excluir o papel",
    "confirmarEliminarRol": "O papel é excluído. Só é possível se ninguém o tiver.",
    "rolDeSistemaNoSeElimina": "Os papéis que vêm com o sistema não se excluem.",
    "sinAcotarSucursales": "Todas as filiais",
    "sobreUnoMismo": "Sobre si mesmo não se muda o papel nem se dá baixa: ficar de fora da própria empresa não se conserta por dentro."
  },
  "configuracion": {
    "titulo": "Configuração",
    "descripcion": "Como o seu comércio trabalha.",
    "clases": {
      "libre": "Livre",
      "con_corte": "Requer corte",
      "fijado_al_inicio": "Definido no início"
    },
    "motivos": {
      "libre": "Vale daqui em diante; não mexe no que já foi registrado.",
      "con_corte": "Alterá-lo reinterpreta operações já registradas, então ainda está bloqueado.",
      "fijado_al_inicio": "Foi definido ao cadastrar a empresa."
    },
    "datosDelComercio": "Os dados do comércio",
    "ayudaDatosDelComercio": "O que sai nos comprovantes e no cupom. A identificação e a condição perante o IVA não mudam daqui: o já faturado as leva."
  },
  "alta": {
    "titulo": "Vamos cadastrar seu comércio",
    "crear": "Criar o comércio",
    "progreso": "Passo {{actual}} de {{total}}",
    "paso1": "Dados fiscais",
    "paso2": "Como você trabalha",
    "paso3": "Seu primeiro local",
    "nombre": "Nome do comércio",
    "ayudaNombre": "Como as pessoas conhecem",
    "razonSocial": "Razão social",
    "ayudaRazonSocial": "Como consta no papel",
    "ayudaIdentificacion": "Com ou sem hífens. Por exemplo: {{ejemplo}}",
    "tipoDeIdentificacion": "Tipo de identificação",
    "condicionIva": "Situação fiscal",
    "pais": "País",
    "jurisdiccion": "Província, região ou departamento",
    "sinJurisdiccion": "Não informado",
    "monedaDelPais": "Opera em {{moneda}}, a moeda do país. É definida ao criar o comércio e não muda depois.",
    "perfil": "Perfil de negócio",
    "elegirPerfil": "Escolha um perfil",
    "ayudaPerfil": "Deixa a configuração pronta; depois se muda o que precisar.",
    "sucursalNombre": "Nome do local",
    "ayudaSucursal": "Matriz, filial centro, depósito…",
    "sucursalCiudad": "Cidade",
    "loQueSeCrea": "Também são criados um depósito, um caixa e um ponto de venda, para você já poder operar.",
    "sucursalPorDefecto": "Matriz"
  },
  "perfiles": {
    "minorista_monotributo": "Varejo, regime simplificado",
    "minorista_responsable_inscripto": "Varejo, contribuinte inscrito",
    "mayorista": "Atacado",
    "mixto": "Misto"
  },
  "paises": {
    "AR": "Argentina",
    "CL": "Chile",
    "PY": "Paraguai",
    "UY": "Uruguai"
  },
  "jurisdicciones": {
    "AR-C": "Ciudad Autónoma de Buenos Aires",
    "AR-B": "Buenos Aires",
    "AR-K": "Catamarca",
    "AR-H": "Chaco",
    "AR-U": "Chubut",
    "AR-X": "Córdoba",
    "AR-W": "Corrientes",
    "AR-E": "Entre Ríos",
    "AR-P": "Formosa",
    "AR-Y": "Jujuy",
    "AR-L": "La Pampa",
    "AR-F": "La Rioja",
    "AR-M": "Mendoza",
    "AR-N": "Misiones",
    "AR-Q": "Neuquén",
    "AR-R": "Río Negro",
    "AR-A": "Salta",
    "AR-J": "San Juan",
    "AR-D": "San Luis",
    "AR-Z": "Santa Cruz",
    "AR-S": "Santa Fe",
    "AR-G": "Santiago del Estero",
    "AR-V": "Tierra del Fuego",
    "AR-T": "Tucumán",
    "CL-AP": "Arica y Parinacota",
    "CL-TA": "Tarapacá",
    "CL-AN": "Antofagasta",
    "CL-AT": "Atacama",
    "CL-CO": "Coquimbo",
    "CL-VS": "Valparaíso",
    "CL-RM": "Región Metropolitana de Santiago",
    "CL-LI": "Libertador General Bernardo O'Higgins",
    "CL-ML": "Maule",
    "CL-NB": "Ñuble",
    "CL-BI": "Biobío",
    "CL-AR": "La Araucanía",
    "CL-LR": "Los Ríos",
    "CL-LL": "Los Lagos",
    "CL-AI": "Aysén",
    "CL-MA": "Magallanes y de la Antártica Chilena",
    "PY-ASU": "Asunción",
    "PY-1": "Concepción",
    "PY-2": "San Pedro",
    "PY-3": "Cordillera",
    "PY-4": "Guairá",
    "PY-5": "Caaguazú",
    "PY-6": "Caazapá",
    "PY-7": "Itapúa",
    "PY-8": "Misiones",
    "PY-9": "Paraguarí",
    "PY-10": "Alto Paraná",
    "PY-11": "Central",
    "PY-12": "Ñeembucú",
    "PY-13": "Amambay",
    "PY-14": "Canindeyú",
    "PY-15": "Presidente Hayes",
    "PY-16": "Alto Paraguay",
    "PY-19": "Boquerón",
    "UY-AR": "Artigas",
    "UY-CA": "Canelones",
    "UY-CL": "Cerro Largo",
    "UY-CO": "Colonia",
    "UY-DU": "Durazno",
    "UY-FS": "Flores",
    "UY-FD": "Florida",
    "UY-LA": "Lavalleja",
    "UY-MA": "Maldonado",
    "UY-MO": "Montevideo",
    "UY-PA": "Paysandú",
    "UY-RN": "Río Negro",
    "UY-RV": "Rivera",
    "UY-RO": "Rocha",
    "UY-SA": "Salto",
    "UY-SJ": "San José",
    "UY-SO": "Soriano",
    "UY-TA": "Tacuarembó",
    "UY-TT": "Treinta y Tres"
  },
  "condicionesFiscales": {
    "AR": {
      "responsable_inscripto": "Responsável inscrito",
      "monotributo": "Monotributo",
      "exento": "Isento",
      "no_responsable": "Não responsável",
      "consumidor_final": "Consumidor final",
      "no_categorizado": "Não categorizado"
    },
    "CL": {
      "regimen_general": "Regime geral (art. 14 A)",
      "pro_pyme_general": "Pro Pyme geral (art. 14 D nº 3)",
      "pro_pyme_transparente": "Pro Pyme transparente (art. 14 D nº 8)",
      "exento": "Isento de IVA",
      "contribuyente": "Contribuinte",
      "consumidor_final": "Consumidor final"
    },
    "PY": {
      "ire_general": "IRE regime geral",
      "ire_simple": "IRE SIMPLE",
      "ire_resimple": "IRE RESIMPLE",
      "contribuyente": "Contribuinte",
      "consumidor_final": "Consumidor final",
      "exento": "Isento"
    },
    "UY": {
      "regimen_general": "Regime geral (IRAE e IVA)",
      "literal_e": "Pequena empresa (literal E)",
      "monotributo": "Monotributo",
      "monotributo_mides": "Monotributo social MIDES",
      "contribuyente": "Contribuinte",
      "consumidor_final": "Consumidor final",
      "exento": "Isento"
    }
  },
  "identificaciones": {
    "CUIT": "CUIT",
    "CUIL": "CUIL",
    "DNI": "DNI",
    "PASAPORTE": "Passaporte",
    "OTRO": "Outro",
    "RUT": "RUT",
    "RUC": "RUC",
    "CI": "Cédula de identidade",
    "SIN_IDENTIFICAR": "Sem identificação"
  },
  "invitacion": {
    "titulo": "Você foi convidado para um comércio",
    "tituloFundacion": "Bem-vindo ao ActualGold!",
    "subtitulo": "Escolha sua senha para entrar.",
    "subtituloFundacion": "Crie sua conta e depois cadastramos seu comércio.",
    "nombre": "Nome",
    "apellido": "Sobrenome",
    "contrasena": "Senha",
    "ayudaContrasena": "Pelo menos doze caracteres. Uma frase é melhor que uma palavra estranha.",
    "aceptar": "Criar minha conta",
    "sinToken": "Este link não é válido. Peça um novo convite."
  },
  "permisos": {
    "EMPRESA": {
      "CONFIGURACION": {
        "VER": "Ver a configuração",
        "EDITAR": "Alterar a configuração"
      },
      "SUCURSAL": {
        "VER": "Ver filiais",
        "CREAR": "Criar filiais",
        "EDITAR": "Editar filiais"
      },
      "DEPOSITO": {
        "VER": "Ver depósitos",
        "CREAR": "Criar depósitos",
        "EDITAR": "Editar depósitos"
      },
      "PUESTO_DE_CAJA": {
        "VER": "Ver caixas",
        "CREAR": "Criar caixas",
        "EDITAR": "Editar caixas"
      },
      "PUNTO_DE_VENTA": {
        "VER": "Ver pontos de venda",
        "CREAR": "Criar pontos de venda",
        "EDITAR": "Editar pontos de venda"
      },
      "MONEDA": {
        "VER": "Ver moedas",
        "EDITAR": "Editar moedas"
      },
      "COTIZACION": {
        "VER": "Ver cotações",
        "CARGAR": "Carregar cotações"
      },
      "CAMPO": {
        "VER": "Ver os campos próprios",
        "ADMINISTRAR": "Definir os campos próprios"
      },
      "EMPRESA": {
        "VER": "Ver os dados do comércio",
        "EDITAR": "Corrigir os dados do comércio"
      }
    },
    "ACCESOS": {
      "ROL": {
        "VER": "Ver papéis",
        "CREAR": "Criar papéis",
        "EDITAR": "Editar papéis",
        "ELIMINAR": "Excluir papéis"
      },
      "MEMBRESIA": {
        "VER": "Ver a equipe",
        "INVITAR": "Convidar pessoas",
        "EDITAR": "Editar a equipe",
        "DESACTIVAR": "Desativar pessoas"
      }
    },
    "AUDITORIA": {
      "REGISTRO": {
        "VER": "Ver a auditoria"
      }
    },
    "CATALOGO": {
      "ARTICULO": {
        "VER": "Ver itens",
        "CREAR": "Criar itens",
        "EDITAR": "Editar itens"
      },
      "UNIDAD": {
        "VER": "Ver unidades de medida",
        "EDITAR": "Editar unidades de medida"
      },
      "CATEGORIA": {
        "VER": "Ver categorias",
        "EDITAR": "Editar categorias"
      }
    },
    "PRECIOS": {
      "LISTA": {
        "VER": "Ver listas de preços",
        "CREAR": "Criar listas de preços",
        "EDITAR": "Editar listas de preços"
      },
      "PRECIO": {
        "VER": "Ver preços",
        "EDITAR": "Alterar preços"
      },
      "AUMENTO": {
        "APLICAR": "Reajustar uma lista inteira"
      }
    },
    "EXISTENCIAS": {
      "SALDO": {
        "VER": "Ver estoque"
      },
      "KARDEX": {
        "VER": "Ver os movimentos de estoque"
      },
      "AJUSTE": {
        "APLICAR": "Ajustar estoque"
      },
      "COSTO": {
        "VER": "Ver o custo do estoque"
      }
    },
    "CAJA": {
      "TURNO": {
        "VER": "Ver os turnos de caixa",
        "ABRIR": "Abrir um turno de caixa",
        "CERRAR": "Fechar um turno de caixa"
      },
      "MOVIMIENTO": {
        "REGISTRAR": "Registrar movimentos de caixa"
      },
      "CONCEPTO": {
        "ADMINISTRAR": "Administrar os conceitos de caixa"
      }
    },
    "VENTAS": {
      "COMPROBANTE": {
        "VER": "Ver comprovantes",
        "EMITIR": "Emitir comprovantes",
        "ANULAR": "Anular um comprovante"
      },
      "PRECIO": {
        "FORZAR": "Vender a um preço diferente do da lista"
      },
      "DESCUENTO": {
        "APLICAR": "Aplicar descontos na venda"
      },
      "CREDITO": {
        "AUTORIZAR": "Autorizar uma venda que ultrapassa o limite de crédito"
      },
      "DEVOLUCION": {
        "REGISTRAR": "Registrar uma devolução",
        "AUTORIZAR_PLAZO": "Autorizar uma devolução fora do prazo"
      },
      "TIPO_DE_COMPROBANTE": {
        "VER": "Ver os tipos de comprovante",
        "ADMINISTRAR": "Configurar os tipos de comprovante"
      },
      "NUMERADOR": {
        "FIJAR": "Fixar em que número está um numerador"
      }
    },
    "TERCEROS": {
      "TERCERO": {
        "VER": "Ver terceiros",
        "CREAR": "Criar terceiros",
        "EDITAR": "Editar terceiros"
      },
      "PROVEEDOR": {
        "VER": "Ver fornecedores",
        "EDITAR": "Editar o perfil de fornecedor"
      },
      "CLIENTE": {
        "VER": "Ver clientes",
        "EDITAR": "Editar o perfil de cliente"
      }
    },
    "COMPRAS": {
      "ORDEN": {
        "VER": "Ver pedidos de compra",
        "CREAR": "Criar pedidos de compra",
        "EMITIR": "Emitir e cancelar pedidos"
      },
      "RECEPCION": {
        "VER": "Ver recebimentos",
        "REGISTRAR": "Registrar recebimentos",
        "ANULAR": "Anular uma recepção"
      },
      "FACTURA": {
        "VER": "Ver notas de fornecedor",
        "REGISTRAR": "Registrar notas de fornecedor",
        "ANULAR": "Anular uma fatura de fornecedor"
      },
      "GASTO": {
        "APLICAR": "Ratear despesas no custo"
      }
    },
    "CUENTAS": {
      "CUENTA": {
        "VER": "Ver contas correntes"
      },
      "AJUSTE": {
        "APLICAR": "Ajustar um saldo de conta corrente"
      },
      "COBRO": {
        "REGISTRAR": "Registrar cobranças",
        "ANULAR": "Anular uma cobrança"
      },
      "PAGO": {
        "REGISTRAR": "Registrar pagamentos a fornecedores",
        "ANULAR": "Anular um pagamento"
      }
    },
    "CONTABILIDAD": {
      "PLAN": {
        "VER": "Ver o plano de contas",
        "ADMINISTRAR": "Adicionar e editar contas do plano"
      },
      "ASIENTO": {
        "VER": "Ver os lançamentos",
        "REGISTRAR": "Registrar lançamentos manuais"
      },
      "REGLA": {
        "ADMINISTRAR": "Configurar a imputação contábil"
      },
      "LIBRO": {
        "VER": "Ver os livros contábeis"
      },
      "EJERCICIO": {
        "ADMINISTRAR": "Abrir, fechar e reabrir exercícios"
      }
    },
    "IMPUESTOS": {
      "LIBRO_DE_IVA": {
        "GENERAR": "Gerar o Livro de IVA Digital"
      }
    },
    "IMPORTACION": {
      "LOTE": {
        "VER": "Ver as importações",
        "APLICAR": "Importar planilhas",
        "REVERTIR": "Desfazer uma importação"
      }
    },
    "BANCOS": {
      "CUENTA": {
        "VER": "Ver as contas bancárias",
        "ADMINISTRAR": "Administrar contas bancárias"
      },
      "VALOR": {
        "VER": "Ver a carteira de cheques",
        "MOVER": "Depositar, endossar e rejeitar cheques"
      },
      "CONCILIACION": {
        "HACER": "Conciliar o extrato bancário"
      }
    },
    "COMISIONES": {
      "REGLA": {
        "ADMINISTRAR": "Configurar as comissões"
      },
      "DEVENGAMIENTO": {
        "VER": "Ver o que cada vendedor ganhou"
      },
      "LIQUIDACION": {
        "HACER": "Liquidar comissões"
      }
    },
    "PRODUCCION": {
      "RECETA": {
        "VER": "Ver as receitas de montagem",
        "ADMINISTRAR": "Definir do que um combo é composto"
      },
      "ARMADO": {
        "HACER": "Montar e desmontar combos"
      }
    },
    "INFORMES": {
      "TABLERO": {
        "VER": "Ver o painel e os relatórios"
      }
    }
  },
  "parametros": {
    "empresa": {
      "zona_horaria": "Fuso horário",
      "idioma": "Idioma do sistema",
      "moneda_base": "Moeda base"
    },
    "impuestos": {
      "modo_de_redondeo": "Como se arredonda"
    },
    "existencias": {
      "permitir_negativo": "Permitir vender sem estoque",
      "criterio_de_costeo": "Critério de custeio"
    },
    "caja": {
      "exigir_turno_para_vender": "Exigir turno de caixa aberto para vender"
    },
    "comisiones": {
      "momento_de_devengamiento": "Quando a comissão é ganha"
    },
    "cuentas_corrientes": {
      "imputacion": "Como os pagamentos são aplicados",
      "bloquear_por_mora": "Bloquear venda a quem está em atraso"
    },
    "devoluciones": {
      "dias_por_defecto": "Dias para devolver",
      "plazo_desde": "O prazo corre"
    },
    "produccion": {
      "habilitada": "Produção habilitada"
    }
  },
  "catalogo": {
    "titulo": "Itens",
    "descripcion": "O que o comércio vende e estoca.",
    "nuevo": "Novo item",
    "buscar": "Buscar por nome ou código",
    "codigo": "Código",
    "nombre": "Nome",
    "marca": "Marca",
    "unidad": "Unidade",
    "tipo": "Tipo",
    "producto": "Produto",
    "servicio": "Serviço",
    "estado": "Situação",
    "activo": "Ativo",
    "inactivo": "Inativo",
    "variantes": "Variantes",
    "sinVariantes": "Sem variantes",
    "vacio": "Ainda não há itens cadastrados.",
    "ayudaCodigo": "O que se digita no balcão. Não se repete.",
    "ayudaUnidad": "Define quantas casas decimais a quantidade aceita: unidade nenhuma, metro sim.",
    "unidadDeStock": "Unidade de medida",
    "controlaExistencia": "Baixa estoque",
    "ayudaControlaExistencia": "Um serviço não baixa estoque; mercadoria sim.",
    "trazabilidad": "Rastreabilidade",
    "trazabilidadNinguno": "Nenhuma",
    "trazabilidadLote": "Por lote",
    "trazabilidadLoteConVencimiento": "Por lote com validade",
    "trazabilidadSerie": "Por número de série",
    "ayudaTrazabilidad": "Com validade, o custo é consumido pelo que vence primeiro, não pelo mais antigo.",
    "esInsumo": "Somente insumo",
    "ayudaEsInsumo": "Comprado e consumido na produção, nunca vendido: não aparece no balcão.",
    "talles": "Tamanhos",
    "colores": "Cores",
    "ayudaCombinaciones": "Separados por vírgula. Cria-se uma variante por combinação; vazios, o item tem uma só.",
    "codigosDeBarra": "Códigos de barras",
    "ayudaCodigosDeBarra": "Separados por vírgula. Só para itens de variante única: com tamanhos carregam-se um a um na ficha.",
    "ficha": "Ficha do item",
    "agregarCodigo": "Adicionar código de barras",
    "codigoDeBarra": "Código de barras",
    "talle": "Tamanho",
    "color": "Cor",
    "sinDetalle": "—",
    "sinDecimales": "Esta unidade não aceita frações: vende-se em números inteiros.",
    "conDecimales": "Esta unidade aceita até {{cantidad}} casas decimais na quantidade.",
    "combinacionesQueSeCrean_one": "Será criada 1 variante",
    "combinacionesQueSeCrean_other": "Serão criadas {{count}} variantes",
    "variantesContadas_one": "1 variante",
    "variantesContadas_other": "{{count}} variantes",
    "corregirArticulo": "Corrigir o item",
    "corregirAyuda": "Muda o catálogo de hoje. Os comprovantes já emitidos seguem dizendo o que diziam.",
    "desactivar": "Desativar",
    "activar": "Ativar",
    "sinCodigoDeBarra": "Sem código de barras",
    "sacarCodigo": "Tirar",
    "paraLaVariante": "Para",
    "verCodigos": "Códigos"
  },
  "precios": {
    "titulo": "Preços",
    "descripcion": "Por quanto se vende cada coisa, em cada lista.",
    "lista": "Lista",
    "expresionNeto": "Preços sem imposto",
    "expresionFinal": "Preços com imposto incluído",
    "buscar": "Buscar por nome ou código",
    "articulo": "Item",
    "codigo": "Código",
    "unidad": "Unidade",
    "precio": "Preço",
    "desde": "Vigente desde",
    "sinPrecio": "Sem preço",
    "vacio": "Ainda não há itens para precificar.",
    "sinCambios": "Nada para salvar",
    "aumentar": "Reajustar a lista",
    "porcentaje": "Percentual",
    "ayudaPorcentaje": "Com sinal de menos baixa os preços. Aplica-se a todos os que já têm preço nesta lista.",
    "redondeo": "Arredondar para",
    "redondeoPeso": "Números inteiros",
    "redondeoCentavo": "Duas casas",
    "redondeoCuatro": "Quatro casas",
    "ayudaRedondeo": "O arredondamento é sempre declarado: reajustar 12% e deixar preços de 1.234,5678 é correto e comercialmente inútil.",
    "historial": "Histórico",
    "historialDe": "Histórico do preço de {{articulo}}",
    "motivo": "Motivo",
    "anterior": "Anterior",
    "quien": "Quem",
    "motivoCarga": "Carga",
    "motivoCorreccion": "Correção",
    "motivoAumentoDeLista": "Reajuste de lista",
    "motivoImportacion": "Importação",
    "sinHistorial": "Este preço ainda não tem histórico.",
    "guardar_one": "Salvar 1 alteração",
    "guardar_other": "Salvar {{count}} alterações",
    "guardados_one": "Pronto: 1 preço salvo.",
    "guardados_other": "Pronto: {{count}} preços salvos.",
    "faltan_one": "Falta 1 sem preço",
    "faltan_other": "Faltam {{count}} sem preço",
    "aplicaA_one": "Vai alterar 1 preço desta lista.",
    "aplicaA_other": "Vai alterar {{count}} preços desta lista.",
    "aumentados_one": "Pronto: 1 preço atualizado.",
    "aumentados_other": "Pronto: {{count}} preços atualizados.",
    "costoDeReposicion": "Custo de reposição",
    "sinCosto": "Carregar",
    "cargarCosto": "Custo de reposição",
    "moneda": "Moeda",
    "ayudaCosto": "O que custaria comprar hoje. É a base do recálculo de preços.",
    "esPredeterminada": "Padrão",
    "programar": "Programar",
    "programarPara": "Programar um preço para {{articulo}}",
    "ayudaProgramar": "O preço de hoje não muda: o novo entra sozinho no dia indicado, logo cedo, e fica no histórico.",
    "precioProgramado": "Preço novo",
    "desdeElDia": "A partir do dia",
    "programados": "Preços programados",
    "ayudaProgramados": "O que entra sozinho nesta lista, e quando. Pode ser cancelado enquanto espera.",
    "precioDeHoy": "Preço de hoje",
    "motivoProgramado": "Programado"
  },
  "existencias": {
    "titulo": "Estoque",
    "descripcion": "Quanto há de cada coisa, onde, e quanto custou.",
    "deposito": "Depósito",
    "todos": "Todos os depósitos",
    "buscar": "Buscar por nome ou código",
    "codigo": "Código",
    "articulo": "Item",
    "unidad": "Unidade",
    "cantidad": "Quantidade",
    "valorizacion": "Valorizado",
    "vacio": "Ainda não há estoque registrado.",
    "ajustar": "Ajustar estoque",
    "motivo": "Motivo",
    "ayudaMotivo": "Obrigatório. Um ajuste sem motivo é uma diferença sem explicação, e três meses depois ninguém lembra por que faltavam seis.",
    "motivoExistenciaInicial": "Estoque inicial",
    "motivoConteo": "Diferença de contagem",
    "motivoRotura": "Quebra",
    "motivoFaltante": "Falta",
    "motivoSobrante": "Sobra",
    "motivoUsoInterno": "Uso interno",
    "motivoDevolucionAProveedor": "Devolução ao fornecedor",
    "buscarArticulo": "Item",
    "ayudaCantidad": "Com sinal de menos para retirar.",
    "costoUnitario": "Custo unitário",
    "ayudaCosto": "Obrigatório na entrada. É o que depois vai dizer quanto custou o que for vendido.",
    "lote": "Lote",
    "vencimiento": "Validade",
    "ayudaVencimiento": "Se preenchida, esta mercadoria sai antes da que vence depois, mesmo tendo entrado mais tarde.",
    "agregarLinea": "Adicionar linha",
    "quitar": "Remover",
    "aplicar": "Aplicar o ajuste",
    "aplicado_other": "Pronto: {{count}} movimentos registrados.",
    "kardex": "Movimentos",
    "kardexDe": "Movimentos de {{articulo}}",
    "cuando": "Quando",
    "origen": "Origem",
    "quien": "Quem",
    "observacion": "Observação",
    "origenAjuste": "Ajuste",
    "origenVenta": "Venda",
    "origenDevolucion": "Devolução",
    "origenCompra": "Compra",
    "origenTransferencia": "Transferência",
    "origenProduccion": "Produção",
    "sinMovimientos": "Sem movimentos.",
    "entra": "Entra",
    "sale": "Sai",
    "aplicado_one": "Pronto: {{count}} movimento registrado."
  },
  "caja": {
    "titulo": "Caixa",
    "descripcion": "O turno do caixa: o que entrou, o que saiu e quanto deve haver.",
    "puesto": "Caixa",
    "sinTurno": "Este caixa não tem turno aberto.",
    "abrir": "Abrir turno",
    "saldoInicial": "Dinheiro na gaveta",
    "ayudaSaldoInicial": "O que há agora, contado. Não se herda do fechamento anterior de propósito: herdar transforma o erro de uma noite no ponto de partida da manhã.",
    "turnoNumero": "Turno {{numero}}",
    "abiertoPor": "Aberto por {{quien}}",
    "movimiento": "Registrar movimento",
    "tipo": "Tipo",
    "ingreso": "Entrada",
    "egreso": "Saída",
    "medioDePago": "Meio de pagamento",
    "importe": "Valor",
    "concepto": "Descrição",
    "efectivo": "Dinheiro",
    "debito": "Débito",
    "credito": "Crédito",
    "transferencia": "Transferência",
    "cheque": "Cheque",
    "otro": "Outro",
    "cuando": "Quando",
    "quien": "Quem",
    "movimientos": "Movimentos do turno",
    "sinMovimientos": "Ainda não há movimentos.",
    "arqueo": "Conferência",
    "esperado": "Deve haver em dinheiro",
    "ayudaArqueo": "Só o dinheiro é contado. O recebido em cartão ou transferência fica registrado, mas não está na gaveta.",
    "cerrar": "Fechar turno",
    "declarado": "Dinheiro contado",
    "ayudaDeclarado": "O que há de verdade, contado agora. Se não bater, a diferença fica registrada com o seu nome.",
    "observacion": "Observação",
    "ayudaObservacion": "Se houver diferença, o que você souber do porquê.",
    "diferencia": "Diferença",
    "sobra": "Sobra",
    "falta": "Falta",
    "cuadra": "Bate exato",
    "cerrado": "Pronto: turno fechado. Esperado {{esperado}}, contado {{declarado}}, diferença {{diferencia}}.",
    "tipoApertura": "Abertura",
    "tipoVenta": "Venda",
    "tipoDevolucion": "Devolução",
    "tipoIngreso": "Entrada",
    "tipoEgreso": "Saída",
    "tipoRedondeo": "Arredondamento",
    "tipoDiferenciaDeArqueo": "Diferença de conferência",
    "historia": "Turnos anteriores",
    "estado": "Situação",
    "estadoAbierto": "Aberto",
    "estadoCerrado": "Fechado",
    "sinTurnos": "Ainda não foi aberto nenhum turno.",
    "turno": "Turno",
    "queEs": "O que é?",
    "queGasto": "Uma despesa ou uma entrada",
    "quePago": "Um pagamento a um fornecedor",
    "queCobro": "Um recebimento de um cliente",
    "queDeposito": "Um depósito no banco",
    "queDueno": "Uma retirada ou um aporte do dono",
    "clasificarCon": "Classifica-se com",
    "conConcepto": "Um conceito",
    "conCuenta": "Uma conta do plano",
    "conceptoDeCaja": "Conceito",
    "elegirConcepto": "Escolha um conceito",
    "cuentaDelPlan": "Conta",
    "elegirCuenta": "Escolha uma conta",
    "ayudaCuenta": "Só as que se podem mover pelo caixa: não estão o caixa, os bancos, as contas correntes, o estoque nem o IVA, que se movem pela sua própria operação.",
    "retiro": "Retirada",
    "aporte": "Aporte",
    "ayudaDueno": "Vai contra a conta particular do dono, no patrimônio: não é uma despesa do comércio.",
    "sinConceptoDelDueno": "Falta o conceito do dono ou está desativado: revise em Configuração → Conceitos de caixa.",
    "cuentaBancaria": "Conta bancária",
    "elegirCuentaBancaria": "Escolha a conta",
    "sinCuentasBancarias": "Não há contas bancárias: cadastre em Bancos.",
    "ayudaDeposito": "Sai do caixa e entra na conta hoje mesmo.",
    "proveedor": "Fornecedor",
    "cliente": "Cliente",
    "elegirTercero": "Escolha quem",
    "ayudaTercero": "O dinheiro passa pelo turno de {{puesto}}. Ao lado de cada um, quanto se deve.",
    "sinProveedores": "Não se deve nada a nenhum fornecedor.",
    "sinClientes": "Nenhum cliente deve nada.",
    "avisoIva": "Com fatura A, lance como fatura de fornecedor e pague daqui com «Um pagamento a um fornecedor»: assim o IVA é computado. O que se lança aqui vai inteiro para a despesa.",
    "detalle": "Detalhe",
    "ayudaDetalle": "O que for preciso para entender depois: a quem, por quê.",
    "seguir": "Continuar",
    "revertir": "Reverter",
    "confirmarReversion": "Reverter «{{concepto}}»? Registra-se o movimento inverso, com seu lançamento, e o original continua visível.",
    "tipoCobranza": "Recebimento",
    "tipoPago": "Pagamento",
    "tipoDeposito": "Depósito"
  },
  "venta": {
    "mostrador": "Balcão",
    "mayorista": "Entrada por atacado",
    "descripcionMostrador": "Passe o leitor ou busque pelo nome. Tudo funciona pelo teclado.",
    "descripcionMayorista": "Código, quantidade e desconto. Enter adiciona e segue.",
    "buscar": "Código, código de barras ou nome",
    "codigo": "Código",
    "articulo": "Item",
    "cantidad": "Quantidade",
    "precio": "Preço",
    "bonificacion": "Desc. %",
    "importe": "Valor",
    "quitar": "Remover",
    "vacia": "A venda está vazia. Passe o leitor ou digite um código.",
    "subtotal": "Subtotal",
    "descuento": "Descontos",
    "redondeo": "Arredondamento",
    "total": "Total",
    "medioDePago": "Como paga",
    "efectivo": "Dinheiro",
    "debito": "Débito",
    "credito": "Crédito",
    "transferencia": "Transferência",
    "entregado": "Com quanto paga",
    "vuelto": "Troco",
    "falta": "Falta",
    "cobrar": "Receber",
    "cancelar": "Cancelar a venda",
    "cobrada": "Comprovante {{clase}} {{numero}} recebido por {{total}}.",
    "vueltoDe": "Troco: {{importe}}",
    "sinTurno": "Não há turno de caixa aberto neste posto. Abra antes de vender.",
    "irACaja": "Ir para Caixa",
    "sinResultados": "Nenhum artigo corresponde.",
    "atajos": "F2 recebe · Esc limpa a busca · Del remove a linha",
    "atajosMayorista": "Enter adiciona e volta ao código · F2 recebe · Esc esvazia a venda",
    "agregar": "Adicionar",
    "puesto": "Caixa",
    "lista": "Lista de preços",
    "ultimoTicket": "Último: ticket {{numero}} por {{total}}",
    "sinPrecio": "Sem preço cadastrado",
    "menosUno": "Remover um",
    "masUno": "Adicionar um",
    "sinPrecioEnLista": "O item {{codigo}} não tem preço nesta lista. Cadastre antes de vender.",
    "cliente": "Cliente",
    "consumidorFinal": "Consumidor final",
    "buscarCliente": "Buscar cliente",
    "quitarCliente": "Remover o cliente",
    "clase": "Comprovante {{clase}}",
    "claseExplicacion": "A letra decorre da condição do comércio frente ao IVA e da do cliente. Não se escolhe.",
    "sinClientesQueCoincidan": "Nenhum cliente corresponde.",
    "debeEnCuenta": "Deve {{importe}} em conta",
    "sinDeuda": "Sem dívida",
    "cuenta_corriente": "Conta corrente",
    "necesitaCliente": "Para vender a prazo é preciso identificar o cliente.",
    "autorizarExceso": "Autorizar e cobrar mesmo assim",
    "excesoNoAutorizado": "Só um encarregado pode autorizar ultrapassar o limite.",
    "anular": "Anular esta venda",
    "motivoDeAnulacion": "Por que se anula",
    "confirmarAnulacion": "Anular",
    "tipoDeComprobante": "O que se emite",
    "sinCobro": "Este documento não cobra",
    "emitir": "Emitir",
    "dividirElPago": "Dividir o pagamento",
    "quitarForma": "Tirar esta forma de pagamento",
    "sobra": "Sobra",
    "queSeEmite": "O que se emite",
    "listaFijadaPorElTipo": "Fixada pelo tipo de comprovante.",
    "cajaFijadaPorElTipo": "Fixada pelo tipo de comprovante.",
    "conLaLista": "Preços da lista {{lista}}"
  },
  "ticket": {
    "imprimir": "Imprimir",
    "numero": "Ticket {{numero}}",
    "noFiscal": "Documento não válido como nota fiscal",
    "subtotal": "Subtotal",
    "descuento": "Descontos",
    "redondeo": "Arredondamento",
    "total": "TOTAL",
    "qr": "Código para consultar o ticket",
    "consultaConQr": "Escaneie o código para ver este ticket de novo",
    "verTicket": "Ver o ticket",
    "cliente": "Cliente: {{nombre}}",
    "cuit": "CNPJ/CUIT {{cuit}}",
    "identificacion": "{{tipo}} {{numero}}",
    "domicilio": "Endereço: {{domicilio}}",
    "codigoDeTipo": "Cód. {{codigo}}",
    "fechaDeEmision": "Data de emissão",
    "puntoDeVenta": "Ponto de venda",
    "original": "ORIGINAL",
    "receptor": "Destinatário",
    "sinIdentificar": "Não identificado",
    "neto": "Valor líquido",
    "netoPorAlicuota": "Líquido a {{alicuota}} %",
    "ivaPorAlicuota": "IVA {{alicuota}} %",
    "ivaIncluido": "IVA {{alicuota}} % incluído",
    "ivaTotal": "Total de IVA",
    "verEnHoja": "Ver em folha A4",
    "verEnRollo": "Ver em rolo de 80 mm",
    "cae": "CAE nº {{cae}}",
    "caeVencimiento": "Venc. do CAE: {{fecha}}",
    "sinCae": "Comprovante pendente de autorização",
    "qrDelOrganismo": "Código QR da nota fiscal eletrônica",
    "notaDeCredito": "NOTA DE CRÉDITO",
    "ajusta": "Ajusta o comprovante {{comprobante}}"
  },
  "compras": {
    "proveedores": "Fornecedores",
    "compras": "Compras",
    "descripcionProveedores": "De quem o comércio compra.",
    "descripcionCompras": "O que pedi, o que chegou e o que me cobraram.",
    "nuevoProveedor": "Novo fornecedor",
    "razonSocial": "Razão social",
    "nombreComercial": "Como é chamado",
    "ayudaNombreComercial": "É o que se digita para achá-lo.",
    "tipoDeIdentificacion": "Tipo",
    "identificacion": "Identificação",
    "ayudaIdentificacion": "Guarda-se só com dígitos. Pode escrever com traços.",
    "condicionIva": "Situação fiscal",
    "diasDePago": "Dias de pagamento",
    "ayudaDiasDePago": "Zero é à vista. Daqui sai o vencimento de cada nota.",
    "monedaDelProveedor": "Moeda",
    "telefono": "Telefone",
    "correo": "E-mail",
    "ciudad": "Cidade",
    "esProveedor": "Fornecedor",
    "sinProveedores": "Ainda não há fornecedores.",
    "buscarProveedor": "Buscar por nome ou identificação",
    "ordenes": "Pedidos de compra",
    "nuevaOrden": "Novo pedido",
    "orden": "Pedido",
    "proveedor": "Fornecedor",
    "fecha": "Data",
    "estado": "Situação",
    "total": "Total",
    "estadoBorrador": "Rascunho",
    "estadoEmitida": "Emitido",
    "estadoParcial": "Parcial",
    "estadoCumplida": "Atendido",
    "estadoAnulada": "Cancelado",
    "emitir": "Emitir",
    "anular": "Cancelar",
    "sinOrdenes": "Ainda não há pedidos de compra.",
    "articulo": "Item",
    "cantidad": "Quantidade",
    "precioUnitario": "Preço",
    "bonificacion": "Desc. %",
    "importe": "Valor",
    "agregar": "Adicionar",
    "quitar": "Remover",
    "buscarArticulo": "Código ou nome do item",
    "recepciones": "Recebimentos",
    "nuevaRecepcion": "Registrar recebimento",
    "remito": "Nota de remessa",
    "deposito": "Depósito",
    "costoUnitario": "Custo",
    "lote": "Lote",
    "vencimiento": "Validade",
    "sinRecepciones": "Ainda não chegou nada.",
    "recibida": "Recebimento {{numero}} registrado. O pedido ficou {{estado}}.",
    "recibidaSinOrden": "Recebimento {{numero}} registrado.",
    "facturas": "Notas de fornecedor",
    "nuevaFactura": "Registrar nota",
    "letra": "Letra",
    "puntoDeVenta": "Ponto de venda",
    "numero": "Número",
    "neto": "Líquido",
    "iva": "Imposto",
    "percepciones": "Retenções",
    "vencimientoDePago": "Vence",
    "sinFacturas": "Ainda não há notas lançadas.",
    "conDiferencias": "Com diferenças",
    "sinDiferencias": "Confere",
    "verCotejo": "Ver a conferência",
    "cotejo": "Conferência com o recebido",
    "facturado": "Faturado",
    "recibido": "Recebido",
    "difNoRecibido": "Não chegou",
    "difFacturadoDeMas": "Faturaram a mais",
    "difFacturadoDeMenos": "Faturaram a menos",
    "difPrecioDistinto": "Outro preço",
    "sinFacturar": "Chegou e não faturaram",
    "coincide": "Confere",
    "gasto": "Ratear uma despesa",
    "concepto": "Descrição",
    "criterio": "Ratear",
    "porImporte": "Por valor",
    "porCantidad": "Por quantidade",
    "ayudaCriterio": "Por valor quando a despesa acompanha o valor; por quantidade quando o que se paga é o caminhão.",
    "gastoAplicado": "Pronto. O estoque absorveu {{absorbido}} e {{noAbsorbido}} é custo do período.",
    "ayudaNoAbsorbido": "A parte referente a mercadoria já vendida não pode ser absorvida: o custo daquelas vendas já está registrado.",
    "costoYMargen": "Custo e margem",
    "ultimaCompra": "Última compra",
    "costoDelStock": "O que tenho custa",
    "costoDeReposicion": "Reposição",
    "precioDeVenta": "Preço de venda",
    "margenReal": "Margem realizada",
    "vendidoCantidad": "Vendido",
    "ingreso": "Receita",
    "ayudaMargenReal": "Vem dos comprovantes emitidos, sobre o líquido sem IVA. As devoluções subtraem.",
    "sinDatos": "Sem dados ainda.",
    "ivaCobrado": "IVA cobrado (não é receita)"
  },
  "clientes": {
    "titulo": "Clientes",
    "descripcion": "Para quem o comércio vende. O mesmo terceiro pode ser cliente e fornecedor.",
    "nuevoCliente": "Novo cliente",
    "buscar": "Buscar cliente",
    "sinClientes": "Ainda não há clientes cadastrados.",
    "razonSocial": "Razão social",
    "nombreComercial": "Nome fantasia",
    "ayudaNombreComercial": "Como o chamam. É o que se digita para encontrá-lo.",
    "tipoDeIdentificacion": "Tipo de identificação",
    "identificacion": "Identificação",
    "ayudaIdentificacion": "Escreva como está no papel, com ou sem traços.",
    "condicionIva": "Situação frente ao IVA",
    "limiteDeCredito": "Limite de crédito",
    "ayudaLimite": "Zero significa sem crédito. Vazio também.",
    "sinLimite": "Sem limite",
    "noSeLeFia": "Sem crédito",
    "diasDePago": "Dias de pagamento",
    "ayudaDiasDePago": "Zero é à vista.",
    "contado": "À vista",
    "tambienProveedor": "Também",
    "esProveedor": "Fornecedor",
    "telefono": "Telefone",
    "correo": "E-mail",
    "seguimiento": "Acompanhamento",
    "filtrarPorEtiqueta": "Filtrar por etiqueta",
    "todasLasEtiquetas": "Todas"
  },
  "cuentas": {
    "titulo": "Contas correntes",
    "descripcion": "Quem deve e quanto, do maior para o menor.",
    "cliente": "Cliente",
    "identificacion": "Identificação",
    "saldo": "Saldo",
    "limite": "Limite",
    "sinLimite": "Sem limite",
    "aFavor": "{{importe}} a favor",
    "acciones": "Ações",
    "verFicha": "Ver a ficha",
    "ajustar": "Ajustar",
    "nadieDebe": "Ninguém deve nada.",
    "ajustarSaldo": "Ajustar o saldo",
    "importeDelAjuste": "Valor",
    "ayudaImporteDelAjuste": "Com sinal: positivo aumenta a dívida, negativo diminui.",
    "motivo": "Motivo",
    "ayudaMotivo": "Fica escrito no livro e na auditoria.",
    "tipos": {
      "venta": "Venda",
      "cobro": "Cobrança",
      "ajuste": "Ajuste"
    },
    "cobrar": "Cobrar",
    "cobranza": "Cobrança de {{cliente}}",
    "medioDePago": "Meio de pagamento",
    "importe": "Valor",
    "agregarMedio": "Adicionar outro meio",
    "quitarMedio": "Remover",
    "pendientes": "Documentos com dívida",
    "sinPendientes": "Não há documentos pendentes. O que for cobrado fica a crédito.",
    "pendiente": "Falta",
    "aImputar": "Aplica-se",
    "totalCobrado": "Total cobrado",
    "totalImputado": "Aplicado a documentos",
    "aCuenta": "Adiantado e sem aplicar",
    "propuesta": "Proposto: o mais antigo primeiro. Pode ser alterado.",
    "registrar": "Registrar a cobrança",
    "cobrado": "Recibo {{numero}} de {{total, importe}}. Saldo: {{saldo, importe}}.",
    "observaciones": "Observações",
    "enCaja": "Entra no turno de caixa aberto",
    "estadoDeCuenta": "Extrato",
    "comoCliente": "Conta como cliente",
    "comoProveedor": "Conta como fornecedor",
    "fecha": "Data",
    "concepto": "Descrição",
    "acumulado": "Saldo",
    "vence": "Vence",
    "antiguedad": "Antiguidade",
    "alDia": "Em dia",
    "hasta30": "1 a 30",
    "hasta60": "31 a 60",
    "hasta90": "61 a 90",
    "masDe90": "Mais de 90",
    "verEstado": "Extrato",
    "porTramos": "Dívida por antiguidade",
    "anular": "Anular",
    "motivoDeAnulacion": "Por que se anula",
    "confirmarAnulacion": "Confirmar a anulação",
    "anulado": "Anulado",
    "anulada": "Anulada",
    "numeroDeCheque": "Número do cheque",
    "bancoDelCheque": "Banco",
    "fechaDeCobro": "Data de cobrança",
    "recibo": "Recibo {{numero}}",
    "aplicar": "Aplicar"
  },
  "pagos": {
    "titulo": "Pagamentos a fornecedores",
    "descripcion": "A quem o comércio deve, do maior para o menor.",
    "proveedor": "Fornecedor",
    "pagar": "Pagar",
    "orden": "Ordem de pagamento para {{proveedor}}",
    "facturas": "Faturas pendentes",
    "sinFacturas": "Não há faturas pendentes. O que for pago fica a crédito.",
    "registrar": "Registrar o pagamento",
    "pagado": "Ordem {{numero}} de {{total, importe}}. Saldo: {{saldo, importe}}.",
    "nadieCobra": "Não se deve nada a ninguém.",
    "sale": "Sai do turno de caixa aberto",
    "endosar": "Endossar cheques da carteira",
    "sinCartera": "Não há cheques na carteira.",
    "seCobra": "Vence",
    "totalEndosado": "Total endossado"
  },
  "devoluciones": {
    "titulo": "Devoluções",
    "descripcion": "O cliente trouxe mercadoria: busca-se a venda e devolve-se o que corresponde.",
    "buscar": "Número do ticket",
    "buscarAyuda": "É o número impresso no papel.",
    "sinResultados": "Nenhuma venda com esse número.",
    "venta": "Ticket {{numero}}",
    "fecha": "Data",
    "total": "Total",
    "cliente": "Cliente",
    "consumidorFinal": "Consumidor final",
    "elegir": "Devolver desta venda",
    "articulo": "Artigo",
    "vendida": "Vendida",
    "yaDevuelta": "Já devolvida",
    "disponible": "Resta",
    "aDevolver": "Devolve-se",
    "motivo": "Por que se devolve",
    "registrar": "Registrar a devolução",
    "hecha": "Devolução {{numero}} de {{total, importe}}. Em dinheiro: {{enEfectivo, importe}}. A crédito: {{aCuenta, importe}}.",
    "fueraDePlazo": "Autorizar e devolver mesmo assim",
    "sinAutorizacion": "Só um encarregado pode autorizar uma devolução fora do prazo.",
    "nadaQueDevolver": "Desta venda já foi devolvido tudo.",
    "cambiar": "Trocar por outro artigo",
    "loQueSeLleva": "O que leva",
    "buscarArticulo": "Buscar o artigo que leva",
    "diferenciaAPagar": "O cliente paga",
    "diferenciaADevolver": "Devolve-se",
    "sinDiferencia": "Sem diferença",
    "registrarCambio": "Registrar a troca",
    "soloDevolver": "Apenas devolver",
    "cambioHecho": "Troca feita: devolução {{devolucion}} e ticket {{venta}}. Diferença: {{diferencia, importe}}.",
    "hechaComoNota": "Nota de crédito {{numero}} por {{total, importe}}. Em dinheiro: {{enEfectivo, importe}}. A favor: {{aCuenta, importe}}."
  },
  "contabilidad": {
    "titulo": "Plano de contas",
    "descripcion": "Onde se lança cada coisa que acontece no comércio.",
    "nueva": "Nova conta",
    "ayudaNueva": "Fica abaixo da conta que você escolher e herda o tipo dela.",
    "codigo": "Código",
    "nombre": "Nome",
    "tipo": "Tipo",
    "cuelgaDe": "Abaixo de",
    "ninguna": "Nenhum grupo",
    "imputable": "Lançável",
    "agrupacion": "Agrupamento",
    "desactivar": "Desativar",
    "activar": "Ativar",
    "inactiva": "Inativa",
    "renombrar": "Renomear",
    "ayudaRenombrar": "O código {{codigo}} não muda. Os livros de todos os períodos vão mostrar a conta com o nome novo.",
    "vacio": "Ainda não há contas cadastradas.",
    "ayudaTipo": "Só um grupo do topo escolhe; uma conta abaixo de outra herda o tipo dela.",
    "tipos": {
      "activo": "Ativo",
      "pasivo": "Passivo",
      "patrimonio": "Patrimônio líquido",
      "resultado_positivo": "Resultado positivo",
      "resultado_negativo": "Resultado negativo"
    }
  },
  "asientos": {
    "titulo": "Lançamentos",
    "descripcion": "Como cada operação ficou registrada na contabilidade.",
    "numero": "Número",
    "fecha": "Data",
    "glosa": "Histórico",
    "importe": "Valor",
    "cuenta": "Conta",
    "debe": "Débito",
    "haber": "Crédito",
    "verOperacion": "Ver a operação",
    "vacio": "Ainda não há lançamentos.",
    "totales": "Totais",
    "cuadra": "Fecha",
    "tipo": "Tipo",
    "tipos": {
      "venta": "Venda",
      "devolucion": "Devolução",
      "cobranza": "Cobrança",
      "pago": "Pagamento",
      "recepcion": "Recebimento",
      "factura_de_compra": "Nota fiscal de compra",
      "diferencia_de_caja": "Diferença de caixa"
    },
    "referencias": {
      "comprobante": "Documento",
      "recepcion": "Recebimento",
      "factura_de_proveedor": "Nota do fornecedor",
      "recibo_de_cobranza": "Recibo de cobrança",
      "orden_de_pago": "Ordem de pagamento",
      "turno_de_caja": "Turno de caixa"
    }
  },
  "libros": {
    "titulo": "Livros contábeis",
    "descripcion": "Diário, razão, balancete e demonstração de resultados, por período.",
    "libro": {
      "diario": "Diário",
      "mayor": "Razão",
      "sumas": "Balancete",
      "resultados": "Resultados"
    },
    "desde": "De",
    "hasta": "Até",
    "cuenta": "Conta",
    "nombre": "Nome",
    "elegirCuenta": "Escolha uma conta",
    "numero": "Número",
    "fecha": "Data",
    "glosa": "Histórico",
    "importe": "Valor",
    "debe": "Débito",
    "haber": "Crédito",
    "acumulado": "Saldo",
    "saldoAnterior": "Saldo anterior",
    "saldoFinal": "Saldo final",
    "saldoDeudor": "Saldo devedor",
    "saldoAcreedor": "Saldo credor",
    "totales": "Totais",
    "cuadra": "Confere",
    "noCuadra": "Não confere",
    "positivos": "Resultados positivos",
    "negativos": "Resultados negativos",
    "totalPositivos": "Total de resultados positivos",
    "totalNegativos": "Total de resultados negativos",
    "ganancia": "Lucro do período",
    "perdida": "Prejuízo do período",
    "planilla": "Baixar planilha",
    "vacio": "Não houve movimentos neste período."
  },
  "libroDeIva": {
    "titulo": "Livro de IVA Digital",
    "descripcion": "Os arquivos da RG 4597 para apresentar o período à ARCA.",
    "periodo": "Período",
    "generar": "Gerar",
    "bajar": "Baixar",
    "renglones": "{{renglones}} linhas",
    "registros": "{{total}} documentos",
    "sinMovimientos": "Sem movimentos",
    "todaviaNada": "Escolha um período e gere o livro.",
    "avisoDeCodificacion": "Os arquivos são baixados em ISO 8859-1, como o regime exige. Não os salve de novo em UTF-8: em um arquivo de posições fixas um acento a mais desloca a linha inteira e o órgão rejeita tudo."
  },
  "ejercicios": {
    "titulo": "Exercícios",
    "descripcion": "O período contábil, seu fechamento, e os lançamentos que uma pessoa escreve.",
    "nombre": "Nome",
    "periodo": "Período",
    "estado": "Situação",
    "estados": {
      "abierto": "Aberto",
      "cerrado": "Fechado"
    },
    "abrir": "Abrir exercício",
    "cerrar": "Fechar",
    "reabrir": "Reabrir",
    "reabrirAyuda": "Nada é apagado: escrevem-se os lançamentos inversos do fechamento e da apuração, e fica registrado quem e por quê.",
    "motivo": "Motivo",
    "cerrado": "Fechado. Resultado do exercício: {{resultado}}.",
    "asientoManual": "Lançamento manual",
    "asientoManualAyuda": "O único lançamento que não nasce de uma operação. Por isso fica com seu nome e seu motivo.",
    "fecha": "Data",
    "glosa": "Histórico",
    "cuenta": "Conta",
    "lado": "Lado",
    "elegirCuenta": "Escolha uma conta",
    "otroRenglon": "Outra linha",
    "desde": "De",
    "hasta": "Até",
    "vacio": "Ainda não há exercícios. Abra um para poder fechar o ano."
  },
  "respaldos": {
    "titulo": "Backup dos dados",
    "ultimo": "Último backup: {{cuando}}",
    "verificado": "Verificado",
    "sinVerificar": "Não foi possível verificar",
    "afuera": "Copiado para fora da máquina",
    "noSubio": "Não foi possível copiar para fora",
    "soloAca": "Somente nesta máquina",
    "ninguno": "Nenhum backup foi feito ainda."
  },
  "preparacion": {
    "titulo": "Para poder operar",
    "todoListo": "Tudo pronto",
    "todoListoAyuda": "O comércio tem tudo o que precisa para vender.",
    "puedeOperar": "Pode vender",
    "noPuedeOperar": "Ainda não pode vender",
    "resolver": "Resolver",
    "yMas": "e mais {{total}}",
    "estados": {
      "falta": "Falta",
      "atencion": "Atenção",
      "listo": "Pronto"
    },
    "requisitos": {
      "SUCURSAL": "Uma filial ativa",
      "DEPOSITO": "Um depósito para a mercadoria",
      "PUNTO_DE_VENTA": "Um ponto de venda para emitir documentos",
      "PUESTO_DE_CAJA": "Um caixa",
      "LISTA_DE_PRECIOS": "Uma lista de preços",
      "ARTICULO": "Ao menos um item no catálogo",
      "PRECIO": "Preços carregados: um item sem preço não pode ser vendido",
      "PLAN_DE_CUENTAS": "O plano de contas",
      "EJERCICIO": "Um exercício contábil aberto que inclua hoje",
      "CERTIFICADO_FISCAL": "O certificado para pedir o CAE: sem ele os documentos não são autorizados",
      "REGLAS_DE_IMPUTACION": "Regras de imputação contábil: sem elas a operação falha ao confirmar"
    }
  },
  "importacion": {
    "titulo": "Importar",
    "descripcion": "Carregar o catálogo de uma planilha, sem gravar nada até confirmar.",
    "elegirArchivo": "Escolha a planilha",
    "leyendo": "Lendo…",
    "vistaPrevia": "Isto é o que vai acontecer",
    "aCrear": "{{total}} serão criados",
    "aOmitir": "{{total}} já existem",
    "conError": "{{total}} não entram",
    "comoSeLeyo": "Lido como {{codificacion}}, separado por «{{separador}}». Colunas: {{columnas}}.",
    "linea": "Linha",
    "clave": "Código",
    "desenlace": "O que acontece",
    "desenlaces": {
      "crear": "Criado",
      "omitir": "Já existe",
      "error": "Não entra"
    },
    "confirmar": "Importar {{total}}",
    "nadaSeEscribio": "Ainda não foi gravado nada.",
    "listo": "Importado",
    "resumen": "{{creadas}} criados · {{omitidas}} ignorados · {{conError}} com erro",
    "anteriores": "Importações anteriores",
    "sinLotes": "Nada importado ainda.",
    "archivo": "Arquivo",
    "cuando": "Quando",
    "quien": "Quem",
    "resultado": "Resultado",
    "entidades": {
      "articulos": "Itens",
      "precios": "Preços",
      "existencias": "Estoque",
      "terceros": "Clientes e fornecedores"
    },
    "ayudas": {
      "articulos": "Colunas: código e nome, e opcionalmente unidade, IVA e marca.",
      "precios": "Colunas: código do item e preço, e opcionalmente a lista. Aceita 1.200,50.",
      "existencias": "Colunas: código do item, quantidade e custo, e opcionalmente o depósito. Registra-se como estoque inicial, com seu movimento, sua camada de custo e seu lançamento.",
      "terceros": "Colunas: razão social, e opcionalmente CNPJ, situação de IVA e se é cliente ou fornecedor."
    },
    "elOrden": "A ordem importa: primeiro os itens, depois seus preços e seu estoque. Clientes e fornecedores quando quiser.",
    "deshacer": "Desfazer",
    "revertido": "Desfeito",
    "deshecho": "{{total}} linhas desfeitas."
  },
  "bancos": {
    "titulo": "Bancos",
    "descripcion": "Onde está o dinheiro que não é espécie.",
    "enElBanco": "No banco",
    "enTransito": "Depositado, sem crédito",
    "enCartera": "Em carteira",
    "cuentas": "Contas",
    "cuenta": "Conta",
    "banco": "Banco",
    "numero": "Número",
    "saldo": "Saldo",
    "cartera": "Cheques em carteira",
    "cheque": "Cheque",
    "deQuien": "De quem",
    "fechaDeCobro": "Cobra-se em",
    "importe": "Valor",
    "fecha": "Data",
    "estado": "Situação",
    "depositos": "Depósitos",
    "acreditar": "Creditar",
    "acreditadoEl": "Creditado em {{fecha}}",
    "depositarEn": "Depositar {{total}} em {{cuenta}}",
    "depositarAyuda": "O dinheiro não entra no banco até você creditar: são dois momentos.",
    "sinCuentas": "Ainda não há contas bancárias.",
    "sinValores": "Não há cheques em carteira.",
    "sinDepositos": "Ainda não foi depositado nada.",
    "conciliacion": "Conciliação",
    "elegiCuenta": "Escolha uma conta.",
    "subirExtracto": "Enviar o extrato (CSV)",
    "extractoCargado": "{{cargadas}} linhas carregadas, {{rechazadas}} descartadas.",
    "diceElBanco": "O que o banco diz e o sistema não explica",
    "diceElSistema": "O que o sistema diz e o banco não confirma",
    "todoExplicado": "Não resta nada do banco sem explicação.",
    "todoConfirmado": "Não resta nada do sistema sem confirmação.",
    "sinCandidato": "Sem candidato",
    "conciliar": "É este",
    "nombre": "Nome",
    "agregarCuenta": "Adicionar conta"
  },
  "comisiones": {
    "titulo": "Comissões",
    "descripcion": "O que cada vendedor ganhou, e o que falta pagar.",
    "pendiente": "Pendente de liquidação",
    "vendedor": "Vendedor",
    "operaciones": "Operações",
    "total": "Total",
    "liquidar": "Liquidar",
    "hasta": "Até",
    "avisoDeLiquidar": "O que se liquida não se recalcula. Se aparecer algo depois, entra na próxima.",
    "reglas": "Regras",
    "categoria": "Categoria",
    "todas": "Todas",
    "porcentaje": "Percentual",
    "sobreElNeto": "O percentual se aplica sobre o valor líquido, sem IVA. A regra de uma categoria prevalece sobre a base do vendedor.",
    "liquidaciones": "Liquidações",
    "periodo": "Período",
    "sinPendientes": "Não há comissões pendentes.",
    "sinReglas": "Nenhuma comissão configurada ainda.",
    "sinLiquidaciones": "Nada liquidado ainda."
  },
  "produccion": {
    "titulo": "Montagem de combos",
    "descripcion": "Juntar componentes num produto vendido como um só.",
    "recetas": "Receitas",
    "combo": "Combo",
    "componentes": "Componentes",
    "componente": "Componente",
    "porCombo": "Por combo",
    "elegir": "Escolher",
    "elegiUno": "Escolha um combo da lista.",
    "armar": "Montar",
    "cantidad": "Quantidade",
    "deposito": "Depósito",
    "costo": "Custo",
    "quien": "Quem",
    "desarmar": "Desmontar",
    "esUnDesarmado": "É uma desmontagem",
    "historial": "Montagens",
    "sinArmados": "Nada foi montado ainda.",
    "sinRecetas": "Nenhum item tem receita.",
    "comoSeCarga": "Uma receita declara do que um combo é composto e em que quantidades.",
    "armado": "Montado. Custou {{costo}}.",
    "costoSaleDeAhi": "O custo do combo vem das camadas consumidas, não de uma média."
  },
  "tablero": {
    "elDia": "O dia",
    "vendido": "Vendido",
    "margen": "Margem",
    "operaciones": "Operações",
    "contraAyer": "{{valor}} % vs ontem",
    "promedio": "Média do mês",
    "plata": "Onde está o dinheiro",
    "enCaja": "No caixa",
    "enBanco": "No banco",
    "enCartera": "Em carteira",
    "enTransito": "Em trânsito",
    "deDondeSale": "O caixa é o dos turnos abertos. O banco e os cheques são de toda a empresa, não de uma filial.",
    "cobrar": "A receber",
    "pendiente": "Pendente",
    "vencido": "Vencido",
    "faltantes": "Sem estoque",
    "faltantesExplicacion": "Itens em zero que venderam nos últimos 30 dias.",
    "vendidas": "{{cuantas}} em 30 dias",
    "porSucursal": "Por filial",
    "sucursal": "Filial",
    "contraAyerCorto": "vs ontem",
    "porciento": "{{valor}} %",
    "sucursalEnCero": "A filial que não vendeu aparece em zero: isso também é informação.",
    "hoy": "Hoje",
    "ayer": "Ontem",
    "concepto": "Conceito",
    "detalle": "Detalhe",
    "valor": "Valor",
    "planilla": "Planilha"
  },
  "terceros": {
    "corregir": "Corrigir os dados",
    "corregirAyuda": "Corrige a ficha. Os comprovantes já emitidos guardam os dados que tinham naquele dia."
  },
  "tiposDeComprobante": {
    "titulo": "Tipos de comprovante",
    "descripcion": "Que documentos o comércio emite e o que cada um faz.",
    "codigo": "Código",
    "nombre": "Nome",
    "signo": "Impacto",
    "queHace": "O que faz",
    "estado": "Estado",
    "suma": "Soma",
    "resta": "Subtrai",
    "noImpacta": "Não impacta",
    "mueveStock": "Movimento de estoque",
    "ninguno": "Não move estoque",
    "descuenta": "Baixa estoque",
    "ingresa": "Entra estoque",
    "esValorizado": "Tem valores",
    "esValorizadoAyuda": "Uma remessa pode não ter.",
    "haceIva": "Declara IVA",
    "haceIvaAyuda": "Entra no livro de IVA do mês.",
    "haceContabilidad": "Lança",
    "haceContabilidadAyuda": "Deixa seu lançamento contábil.",
    "tocaCaja": "Toca o caixa",
    "tocaCajaAyuda": "Move o turno aberto.",
    "afectaCuenta": "Move a conta",
    "afectaCuentaAyuda": "Muda o que o terceiro deve.",
    "pideCae": "Pede CAE",
    "pideCaeAyuda": "É autorizado pelo órgão.",
    "numeraPorPunto": "Numera por ponto de venda",
    "numeraPorPuntoAyuda": "Cada ponto tem sua numeração.",
    "enUso": "Em uso",
    "apagado": "Desligado",
    "encender": "Ligar",
    "apagar": "Desligar",
    "nuevo": "Novo tipo",
    "corregir": "Corrigir o tipo",
    "rigeDesdeAhora": "O que mudar vale para os próximos. Os já emitidos ficam como estão.",
    "laLetraNoSeElige": "A letra do comprovante não se configura: sai da RG 1415 conforme sua condição e a do cliente.",
    "circuito": "Circuito",
    "deQueNace": "De que nasce {{nombre}}",
    "circuitoAyuda": "Os documentos marcados podem virar este. Uma fatura nasce de uma remessa.",
    "listaDePrecios": "Lista de preços",
    "laQueElComercioTenga": "A que a loja tiver posta",
    "listaDePreciosAyuda": "Com quais preços esse tipo é emitido.",
    "listaEsFija": "A lista não se muda",
    "listaEsFijaAyuda": "Quem emite não pode vender com outra lista.",
    "requiereOrigen": "Requer documento anterior",
    "requiereOrigenAyuda": "Não se emite solto: nasce de algum dos tipos do circuito.",
    "dejaPendiente": "Fica pendente até ser convertido",
    "dejaPendienteAyuda": "Um documento dessa origem aparece no Início até existir seu destino.",
    "tiposDelRol": "Quais tipos pode usar",
    "todosLosTipos": "Sem marcar nenhum, pode usar todos.",
    "numerador": "Numerador",
    "numeradorAyuda": "De qual talonário tira o número. Vários tipos podem usar o mesmo.",
    "elDeSuFamilia": "O da sua família fiscal",
    "puestoDeCaja": "Caixa em que incide",
    "puestoDeCajaAyuda": "Com um caixa fixo, quem vende não o escolhe.",
    "laQueElijaQuienVende": "O que escolher quem vende"
  },
  "conversiones": {
    "titulo": "Faturar o entregue",
    "descripcion": "Os documentos que saíram e ainda não foram faturados.",
    "queSeEmite": "O que se emite",
    "facturar": "Faturar {{cuantos}}",
    "total": "Total",
    "nadaPendiente": "Não resta nada a faturar.",
    "sinCliente": "Sem cliente",
    "documentos": "documentos do mesmo cliente",
    "numero": "Comprovante {{numero}}",
    "hecho": "Pronto: emitiu-se o comprovante {{numero}}.",
    "sinCircuito": "Ainda não há nenhum circuito montado.",
    "comoSeArma": "Em Tipos de comprovante, diga a um tipo de quais outros pode nascer.",
    "enCuenta": "Emite-se em conta corrente: a cobrança vem depois, por seu caminho."
  },
  "rubros": {
    "titulo": "Grupos",
    "descripcion": "Como os itens são agrupados. Um item pode estar em vários.",
    "nuevo": "Novo grupo",
    "corregir": "Corrigir grupo",
    "nombre": "Nome",
    "articulos": "Itens",
    "estado": "Situação",
    "activo": "Ativo",
    "inactivo": "Inativo",
    "activar": "Ativar",
    "desactivar": "Desativar",
    "cuelgaDe": "Pendura em",
    "sinPadre": "Não pendura em nenhum",
    "ayudaCuelgaDe": "«Ouro 18k» dentro de «Ouro»: busca-se pelo de cima e aparecem os de baixo.",
    "vacio": "Ainda não há grupos",
    "paraQueSirven": "Agrupam os itens para buscar, precificar e pagar comissão.",
    "delArticulo": "Grupos",
    "ningunoElegido": "Sem grupo",
    "filtrar": "Filtrar por grupo",
    "todos": "Todos os grupos"
  },
  "recalculo": {
    "titulo": "Recalcular preços",
    "descripcion": "O preço sai do custo, não de um número digitado à mão.",
    "lista": "Lista",
    "base": "De onde sai o preço",
    "baseCosto": "Do custo de reposição",
    "basePrecio": "Do preço que já tem",
    "ayudaCosto": "O que custaria comprar hoje, com a margem em cima.",
    "ayudaPrecio": "Um percentual sobre o preço vigente. O aumento parelho de sempre.",
    "utilidad": "Margem sobre o custo (%)",
    "aumento": "Aumento (%)",
    "ayudaUtilidad": "Custo 100 com 40% dá 140. Não é o mesmo que margem sobre a venda, que aparece na tabela.",
    "redondeo": "Arredondamento",
    "valor": "Valor",
    "redondeoDecimales": "Decimais",
    "redondeoMultiplo": "A múltiplo de",
    "redondeoTerminacion": "Terminado em",
    "aQuienesAlcanza": "A quem alcança",
    "proveedor": "Fornecedor",
    "rubro": "Grupo",
    "marca": "Marca",
    "todosLosProveedores": "Todos",
    "todosLosRubros": "Todos",
    "ayudaProveedor": "Sai do histórico de compras: os que alguma vez foram comprados dele.",
    "verQuePasaria": "Ver o que aconteceria",
    "aplicar": "Aplicar a {{count}}",
    "aplicar_one": "Aplicar a 1 preço",
    "aplicar_other": "Aplicar a {{count}} preços",
    "noEscribeNada": "Olhar não muda nada.",
    "aplicado": "{{count}} preço atualizado.",
    "aplicado_one": "1 preço atualizado.",
    "aplicado_other": "{{count}} preços atualizados.",
    "codigo": "Código",
    "articulo": "Item",
    "costo": "Custo",
    "precioAnterior": "Preço de agora",
    "precioNuevo": "Preço novo",
    "margenSobreVenta": "Margem s/ venda",
    "sinPrecio": "Sem preço",
    "sinCosto": "Falta o custo",
    "sinPrecioBase": "Não tem preço do qual partir",
    "cambian": "Mudam",
    "quedanAfuera": "{{count}} ficam de fora",
    "quedanAfuera_one": "1 fica de fora",
    "quedanAfuera_other": "{{count}} ficam de fora",
    "cotizacionUsada": "{{moneda}} a {{valor}}",
    "ningunaAlcanzada": "O filtro não alcança nenhuma variante",
    "aflojaElFiltro": "Tente sem fornecedor, ou sem grupo: combinam-se com «e».",
    "aplicarEl": "Aplicar em",
    "ayudaAplicarEl": "Vazio, agora. Com uma data, os preços novos ficam programados e entram sozinhos nesse dia.",
    "programado_one": "Pronto: {{count}} preço programado para {{fecha}}.",
    "programado_other": "Pronto: {{count}} preços programados para {{fecha}}.",
    "programado": "Pronto: {{count}} preços programados para {{fecha}}."
  },
  "seguimiento": {
    "titulo": "Acompanhamento",
    "tipo": "O que foi",
    "quePaso": "O que aconteceu",
    "volverEl": "Voltar em",
    "ayudaVolverEl": "Com data, fica pendente e aparece no Início.",
    "anotar": "Anotar",
    "queSePaso": "O que aconteceu",
    "sinNotas": "Ainda não há nada anotado.",
    "personas": "Pessoas",
    "nombre": "Nome",
    "cargo": "Cargo",
    "telefono": "Telefone",
    "etiquetas": "Etiquetas",
    "sinEtiquetas": "Ainda não há etiquetas criadas.",
    "venceEl": "Vence {{fecha}}",
    "hecho": "Feito",
    "marcarHecho": "Marcar feito",
    "tipos": {
      "llamada": "Ligação",
      "visita": "Visita",
      "correo": "E-mail",
      "mensaje": "Mensagem",
      "nota": "Nota"
    }
  },
  "pendientes": {
    "titulo": "O que fazer",
    "vencido": "Vencido",
    "vencidos": "{{count}} vencidos",
    "vencidos_one": "1 vencido",
    "vencidos_other": "{{count}} vencidos"
  },
  "circuito": {
    "titulo": "O que falta documentar",
    "esperan": "{{tipo}} esperando seu {{destino}}",
    "resolver": "Resolver"
  },
  "numeradores": {
    "titulo": "Numeradores",
    "descripcion": "Os talonários da loja. Qualquer comprovante pode usar qualquer um.",
    "nuevo": "Novo numerador",
    "corregir": "Corrigir numerador",
    "codigo": "Código",
    "nombre": "Nome",
    "codigoAyuda": "Curto e em maiúsculas. É o que fica impresso no comprovante.",
    "puntoDeVenta": "Ponto de venda",
    "puntoAyuda": "Daqui saem os quatro dígitos. Não se muda depois.",
    "puntoNoSeCambia": "O ponto de venda não se muda: seus quatro dígitos estão impressos em cada comprovante que emitiu.",
    "vaPor": "Está em",
    "tiposQueLoUsan": "Tipos",
    "estado": "Situação",
    "activo": "Ativo",
    "inactivo": "Inativo",
    "activar": "Ativar",
    "desactivar": "Desativar",
    "fijar": "Fixar o número",
    "ultimoNumero": "Último número emitido",
    "fijarAyuda": "Só para frente: retroceder repetiria números já emitidos.",
    "vacio": "Ainda não há numeradores",
    "paraQueSirven": "Cada tipo de comprovante tira seu número de um. Sem nenhum, numeram como sempre."
  },
  "campos": {
    "titulo": "Campos próprios",
    "descripcion": "Os dados que sua loja precisa e nenhuma ficha trazia.",
    "nuevo": "Novo campo",
    "corregir": "Corrigir campo",
    "deQueFicha": "De qual ficha",
    "nombre": "Nome",
    "codigo": "Código",
    "codigoAyuda": "Com o qual será buscado. Propõe-se sozinho a partir do nome.",
    "tipo": "Tipo",
    "tipoAyuda": "O tipo não se muda depois: desativa-se o campo e cria-se outro.",
    "tipoNoSeCambia": "O tipo não se muda: converteria os valores já carregados em outra coisa.",
    "opciones": "Opções",
    "opcionesAyuda": "Uma por linha.",
    "opcionEnUso": "Uma opção escolhida em alguma ficha não se pode tirar.",
    "ayuda": "Ajuda",
    "obligatorio": "Obrigatório",
    "obligatorioAyuda": "Sem valor não se pode salvar a ficha.",
    "estado": "Situação",
    "activo": "Ativo",
    "inactivo": "Inativo",
    "activar": "Ativar",
    "desactivar": "Desativar",
    "si": "Sim",
    "vacio": "Ainda não há campos próprios",
    "paraQueSirven": "Adicione os dados que sua loja precisa e nenhuma ficha trazia.",
    "enLaFicha": "Campos próprios",
    "entidades": {
      "articulo": "Itens",
      "tercero": "Clientes e fornecedores"
    },
    "tipos": {
      "texto": "Texto",
      "texto_largo": "Texto longo",
      "texto_enriquecido": "Texto com formato",
      "numero": "Número",
      "fecha": "Data",
      "si_no": "Sim ou não",
      "lista": "Lista suspensa",
      "imagen": "Imagem",
      "archivo": "Arquivo"
    },
    "verElArchivo": "Ver o arquivo",
    "sacarElArchivo": "Tirar",
    "elegirArchivo": "Escolher arquivo",
    "cambiarArchivo": "Trocar",
    "subiendo": "Enviando…"
  },
  "ficha": {
    "datos": "Dados",
    "unidadFija": "Medido em {{unidad}}. A unidade não muda: reinterpretaria as quantidades já registradas.",
    "variante": "Variante",
    "existencias": "Quanto tem",
    "sinExistencias": "Ainda não há estoque disto",
    "porVariante": "Da primeira variante.",
    "precios": "Por quanto se vende",
    "ayudaPrecios": "Em cada lista, e onde falta carregar.",
    "sinPrecio": "Sem preço",
    "sinPrecios": "Ainda não há listas de preços",
    "movimientos": "O que se movimentou",
    "ayudaMovimientos": "Todas as entradas e saídas, de todos os depósitos.",
    "sinMovimientos": "Ainda não se movimentou",
    "compras": "De quem se comprou",
    "ayudaCompras": "Dos recebimentos, que são os que trazem a mercadoria.",
    "sinCompras": "Ainda não se comprou",
    "quienLoLleva": "Quem leva",
    "ayudaQuienLoLleva": "Clientes com nome. As vendas de balcão sem cliente não contam.",
    "sinClientes": "Nenhum cliente levou ainda",
    "importe": "Valor",
    "ultimaVez": "Última vez",
    "gestionar": "Gerenciar",
    "tambienProveedor": "Também é fornecedor",
    "tambienCliente": "Também é cliente",
    "perfilDeCliente": "Quanto se fia",
    "ayudaPerfilDeCliente": "O teto da conta corrente.",
    "limiteVacio": "Em branco é sem teto. Zero é não fiar.",
    "perfilDeProveedor": "Como se paga",
    "ayudaPerfilDeProveedor": "Os dias da fatura até o vencimento.",
    "cuentaCorriente": "Conta corrente",
    "ayudaCuentaCliente": "O que deve como cliente. Não se compensa com o que se lhe deve.",
    "ayudaCuentaProveedor": "O que se lhe deve como fornecedor. Não se compensa com o que deve.",
    "sinCuenta": "Ainda não há movimentos",
    "comprobantes": "O que se lhe vendeu",
    "ayudaComprobantes": "Os últimos comprovantes, anulados incluídos.",
    "sinComprobantes": "Ainda não se lhe vendeu",
    "queSeLleva": "O que leva",
    "ayudaQueSeLleva": "Por artigo, do que mais gasta ao que menos.",
    "sinVentas": "Ainda não levou nada",
    "ayudaSeguimiento": "O que aconteceu com este cliente e o que fazer depois.",
    "seguimientoAparte": "O registro e os pendentes abrem na sua própria janela.",
    "ayudaOrdenes": "O que se lhe pediu.",
    "sinOrdenes": "Ainda não se lhe pediu nada",
    "ayudaRecepciones": "O que chegou de verdade.",
    "sinRecepciones": "Ainda não chegou nada",
    "ayudaFacturas": "O que cobrou, com as diferenças marcadas.",
    "sinFacturas": "Ainda não faturou",
    "listaDePrecios": "Lista de preços",
    "ayudaListaDePrecios": "Se tiver uma, vende-se com ela enquanto estiver ativa e dentro da validade, a menos que o tipo de comprovante fixe outra.",
    "listaQueNoSirve": "Essa lista não é oferecida hoje —está desativada ou fora da validade—: enquanto isso, vende-se com a seguinte da cadeia.",
    "sinListaPropia": "A que couber"
  },
  "plataforma": {
    "titulo": "Plataforma",
    "descripcion": "Quem entra nesta instalação. O que acontece dentro de cada comércio não se vê daqui.",
    "invitaciones": "Convites para fundar um comércio",
    "ayudaInvitaciones": "Cada um é um link de uso único, válido por catorze dias.",
    "invitar": "Convidar a fundar um comércio",
    "ayudaInvitar": "A pessoa aceita, escolhe sua senha e carrega os dados do seu comércio, que conhece melhor que nós.",
    "correo": "E-mail",
    "comercio": "Comércio",
    "ayudaComercio": "Como se chama, se souber. Serve para reconhecer o convite na lista.",
    "notas": "Notas",
    "emitir": "Emitir o convite",
    "invitacionLista": "O convite foi emitido. O link aparece aqui para ser passado por onde for — e-mail, mensagem, pessoalmente —: não depende de nenhum e-mail ter saído.",
    "enlace": "Link",
    "emitida": "Emitido",
    "vence": "Vence",
    "estado": "Estado",
    "estados": {
      "pendiente": "Pendente",
      "aceptada": "Aceito",
      "revocada": "Revogado",
      "vencida": "Vencido"
    },
    "revocar": "Revogar",
    "sinInvitaciones": "Ainda não se convidou ninguém",
    "sinComercio": "Sem nome ainda",
    "quienSos": "Você entrou como administrador da plataforma.",
    "comercios": "Comércios",
    "ayudaComercios": "Que existem e se estão ativos. O que têm dentro não se vê daqui.",
    "nombre": "Comércio",
    "identificacion": "Identificação",
    "fundado": "Fundado",
    "activo": "Ativo",
    "suspendido": "Suspenso",
    "suspender": "Suspender",
    "reactivar": "Reativar",
    "confirmarSuspension": "Ninguém vai poder entrar, e quem estiver dentro fica de fora no próximo pedido. Nada é apagado.",
    "sinComercios": "Ainda não há comércios",
    "administradores": "Quem administra a instalação",
    "ayudaAdministradores": "Nomeiam-se e removem-se pelo console, no servidor. Daqui só se veem.",
    "nuevoComercio": "Novo comércio",
    "ayudaNuevoComercio": "Cria-se com sua filial, seus papéis e seu dono pronto para entrar. É a mesma fundação que por convite.",
    "elComercio": "O comércio",
    "elDuenio": "Quem vai administrá-lo",
    "sucursal": "Primeira filial",
    "correoDelDuenio": "E-mail do dono",
    "nombreDelDuenio": "Nome do dono",
    "claveDelDuenio": "Senha inicial",
    "ayudaClaveDelDuenio": "Quem administra este comércio, e duas formas de redefinir sua senha. É a conta da pessoa: se é dona de outro comércio, a senha muda para os dois.",
    "crear": "Criar o comércio",
    "comercioCreado": "O comércio está criado. Estes são os dados para entrar; a senha não se mostra de novo.",
    "comercioCreadoConCuenta": "O comércio está criado e foi somado à conta que já tinha esse e-mail: entra com a senha de sempre.",
    "entrarEn": "Entra em",
    "editar": "Editar",
    "editarComercio": "Editar o comércio",
    "ayudaEditarComercio": "A ficha. A identificação e a condição perante o IVA não mudam: o já faturado as leva.",
    "domicilio": "Endereço",
    "ciudad": "Cidade",
    "codigoPostal": "CEP",
    "telefono": "Telefone",
    "correoDelComercio": "E-mail do comércio",
    "borrar": "Apagar",
    "ayudaBorrar": "Apaga-se com tudo o que tem: vendas, pessoas, arquivos. Não há volta. Só um comércio suspenso, e escrevendo sua identificação.",
    "escribiLaIdentificacion": "Escreva a identificação para confirmar",
    "borrarDefinitivamente": "Apagar definitivamente",
    "sinDuenios": "Este comércio não tem dono ativo",
    "claveProvisoria": "Definir uma senha provisória",
    "ayudaClaveProvisoria": "Todas as sessões se encerram e ao entrar tem que escolher a sua. Mostra-se uma única vez.",
    "generarOtra": "Gerar outra",
    "aplicar": "Aplicar",
    "provisoriaPuesta": "Senha provisória definida. Passe a ela; ao entrar tem que trocá-la.",
    "enlaceDeRecuperacion": "Gerar um link",
    "ayudaEnlaceDeRecuperacion": "A pessoa escolhe sua senha com o link. A senha nunca passa por você. Vence, e usa-se uma vez.",
    "enlaceListo": "Link pronto. Passe-o por onde for.",
    "restablecerClave": "Senha do dono"
  },
  "clave": {
    "miClave": "Trocar minha senha",
    "titulo": "Trocar a senha",
    "ayuda": "Com a atual e a nova. As outras sessões da sua conta se encerram; esta continua.",
    "actual": "Senha atual",
    "nueva": "Senha nova",
    "repetir": "Repita a senha nova",
    "ayudaNueva": "12 caracteres ou mais. Uma frase que só você saiba.",
    "noCoinciden": "As duas senhas novas não coincidem.",
    "cambiar": "Trocar a senha",
    "cambiada": "A senha foi trocada.",
    "elegi": "Escolha sua senha",
    "ayudaElegi": "Você entrou com uma senha provisória. Antes de seguir, escolha uma que só você saiba: a provisória vai em «senha atual»."
  },
  "recuperacion": {
    "titulo": "Escolha sua senha nova",
    "ayuda": "Este link usa-se uma única vez.",
    "listo": "A senha foi trocada. Já pode entrar.",
    "entrar": "Ir para entrar",
    "sinToken": "Este link não traz nenhum código. Peça um novo.",
    "confirmar": "Salvar a senha"
  },
  "listasDePrecios": {
    "titulo": "Listas de preços",
    "descripcion": "Com que preços se vende. A venda usa a do cliente, a do tipo de comprovante, a do caixa ou a da filial e, se não houver nenhuma, a padrão.",
    "nueva": "Nova lista",
    "corregir": "Corrigir a lista",
    "codigo": "Código",
    "nombre": "Nome",
    "moneda": "Moeda",
    "expresionDelPrecio": "O preço é",
    "ayudaExpresion": "Final: o que o cliente paga, com IVA. Líquido: sem IVA, como se pensa no atacado.",
    "expresion": {
      "final": "Preço final",
      "neto": "Preço líquido"
    },
    "vigencia": "Vigência",
    "siempre": "Sempre",
    "desde": "A partir de {{desde}}",
    "hasta": "Até {{hasta}}",
    "entre": "De {{desde}} a {{hasta}}",
    "vigenteDesde": "Vale a partir de",
    "vigenteHasta": "Vale até",
    "ayudaVigencia": "Sem datas, vale sempre. Fora da data não é oferecida, e quem a tiver atribuída vende com a seguinte.",
    "tramos": "Faixas",
    "sinTramos": "—",
    "tramo": "a partir de {{desde}}: {{porcentaje}} %",
    "tramosDe": "Faixas por quantidade de {{lista}}",
    "ayudaTramos": "Um desconto por quantidade para todos os artigos da lista: a partir de 10 unidades, 5 % a menos. Vale a faixa mais alta que a linha alcança.",
    "desdeCantidad": "A partir da quantidade",
    "descuento": "Desconto %",
    "agregarTramo": "Adicionar faixa",
    "estado": "Situação",
    "predeterminada": "Padrão",
    "activa": "Ativa",
    "inactiva": "Inativa",
    "fueraDeFecha": "Fora da data",
    "hacerPredeterminada": "Tornar padrão",
    "eliminar": "Excluir",
    "desactivar": "Desativar",
    "activar": "Ativar",
    "eliminada": "Lista excluída.",
    "desactivada": "A lista já vendeu, por isso ficou desativada: não é mais oferecida e suas vendas continuam dizendo com que lista foram feitas.",
    "copiarDe": "Copiar os preços de",
    "sinCopiar": "Não copiar: começar vazia",
    "ayudaCopiar": "A nova herda a moeda e a expressão da copiada.",
    "porcentaje": "Porcentagem",
    "ayudaPorcentaje": "Sobre o preço da outra lista. Com sinal de menos é um desconto: -15.",
    "redondearA": "Arredondar para múltiplo de",
    "ayudaRedondeo": "Vazio, a duas casas decimais. 10 deixa os preços terminados em zero, nunca para baixo.",
    "copiados": "Lista criada com {{cantidad}} preços copiados.",
    "vacio": "Ainda não há listas.",
    "predeterminadaSinVigencia": "A padrão não tem vigência: é ela que garante que sempre haja um preço.",
    "asignada": "Lista de preços"
  },
  "cajaDelEfectivo": {
    "etiqueta": "Caixa do dinheiro",
    "elegir": "Escolha o caixa",
    "ayuda": "O dinheiro passa pelo turno aberto desse caixa, e a contagem o inclui.",
    "sinCajas": "Nenhum caixa tem turno aberto: o dinheiro não passa por nenhum turno.",
    "fija": "O dinheiro passa pelo turno de {{puesto}}."
  },
  "conceptosDeCaja": {
    "titulo": "Conceitos de caixa",
    "descripcion": "Por que entra ou sai dinheiro do caixa quando não é uma venda. Quem lança escolhe o conceito; a conta contábil se escolhe aqui, uma vez.",
    "nombre": "Nome",
    "sentido": "Para",
    "cuenta": "Conta contábil",
    "cuentaNoDisponible": "A conta já não aceita movimentos de caixa: escolha outra.",
    "estado": "Estado",
    "activo": "Ativo",
    "inactivo": "Desativado",
    "corregir": "Corrigir",
    "ayudaCorregir": "Mudar a conta vale para os próximos movimentos: o já lançado não é reescrito.",
    "nuevo": "Novo conceito de caixa",
    "vacio": "Ainda não há conceitos.",
    "sentidos": {
      "egreso": "Saídas",
      "ingreso": "Entradas",
      "ambos": "Ambos"
    }
  }
}
